<template>
  <div class="row" v-if="show">
    <div class="col"></div>
    <div class="col-lg-12">
      <div id="bar" class="bar" style="margin-left: 5px; margin-right: 5px;">
        <div
          v-for="part in parts"
          v-bind:key="part.title"
          class="barPart"
          :class="part.class"
          :style="part.style"
          :title="part.title"
        >{{ part.text }}</div>
      </div>
    </div>
    <div class="col"></div>
  </div>
</template>

<script>
import { getDataDesc, NETTO_INDEX, CURR_FORMAT, DREAMJOBS } from "../js/main.js";
import { T } from '../js/translations';

export default {
  props: {
    taxes: {
      type: Object,
      required: true
    },
    year: {
      type: Number,
      required: true
    },
    lang: String
  },
  data: function() {
    return {
      T: T
    };
  },
  computed: {
    parts: function() {
      var ret = [];
      var DATA_DESC = getDataDesc(this.year, this.lang);
      var sumWidth = 0;
      for (var i = 0; i < DATA_DESC.length; i++) {
        var val = this.taxes[DATA_DESC[i][0]];
        var part = {};
        part.title = DATA_DESC[i][1] + CURR_FORMAT.format(val);
        var width = Math.round((val / this.sum) * 10000) / 100;
        if (i === DATA_DESC.length - 1) {
          width = 100 - sumWidth;
        } else {
          sumWidth += width;
        }
        part.style = {
          background: DATA_DESC[i][2],
          width: width + "%"
        };
        if (i == NETTO_INDEX) {
          part.text = this.T.netto[this.lang] + ": " + CURR_FORMAT.format(val);
          part.class = "barPartNetto";
        }
        ret.push(part);
      }
      return ret;
    },
    sum: function() {
      var sum = 0;
      var DATA_DESC = getDataDesc(this.year);
      for (var i = 0; i < DATA_DESC.length; i++) {
        sum += this.taxes[DATA_DESC[i][0]];
      }
      return sum;
    },
    show: function() {
      return !DREAMJOBS;
    }
  }
};
</script>



// WEBPACK FOOTER //
// TaxBar.vue?6c9c5b0e